<template>
  <q-page padding>
    <grid-usuario @on-select="onSelect" @on-click-novo="onNew" ref="gridUsuarioRef" @on-reset-password="onResetPassword" />
    <q-dialog :value="true" v-if="modalUsuario" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Criar/Editar Usuário</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="modalUsuario = false" />
        </q-card-section>
        <q-card-section>
          <form-usuario :cpf="usuarioSelecionado.cpf" @on-save="onSave"></form-usuario>
        </q-card-section>
      </q-card>
    </q-dialog>
    <!-- <b-modal id="modal-usuario" modal-class="modal-big" size="xl" @hide="onHide" @shown="onOpenModal" title="Cadastrar Usuário" centered :hide-footer="true" :no-close-on-backdrop="true">
      <form-usuario :cpf="usuarioSelecionado.cpf" @on-save="onSave"></form-usuario>
    </b-modal> -->
  </q-page>
</template>

<script>
// import GridUsuario from './GridUsuario'
// import FormUsuario from './FormUsuario'
import { createPasswordReset } from '../../services/usuario'
const GridUsuario = () => import('./GridUsuario')
const FormUsuario = () => import('./FormUsuario')
export default {
  name: 'user',
  data () {
    return {
      usuarioSelecionado: {},
      modalUsuario: false
    }
  },
  mounted () {
  },
  methods: {
    onSelect (usuario) {
      this.usuarioSelecionado = Object.assign({}, usuario)
      this.modalUsuario = true
      // this.$bvModal.show('modal-usuario')
    },

    onNew () {
      this.usuarioSelecionado = {}
      this.modalUsuario = true
      // this.$bvModal.show('modal-usuario')
    },

    onSave () {
      // this.$bvModal.hide('modal-usuario')
      this.usuarioSelecionado = {}
      this.modalUsuario = false
      this.$refs.gridUsuarioRef.getUsuarios()
    },

    onResetPassword(usuario) {
      this.$q.dialog({
        title: 'Atenção',
        message: `Isso vai resetar a senha do usuário ${usuario.nome}`,
        cancel: true,
        persistent: true
      }).onOk(async () => {
        try {
          const response = await createPasswordReset({ email: usuario.email })
          this.$q.dialog({ title: 'Sucesso', message: response })
        } catch (error) {
          console.error(error)
          this.$q.notify({
            color: 'negative',
            position: 'top-right',
            icon: 'report_problem',
            message: error.message
          })
        }
      })
    },

    onOpenModal () {

    },

    onHide () {

    }
  },
  components: {
    GridUsuario,
    FormUsuario
  }
}
</script>

<style>
  .modal-xl {
    max-width: 98% !important;
  }
  /* @media (min-width: 992px)
  .modal-xl {
    max-width: auto !important;
  }

@media (min-width: 576px)
  .modal-dialog {
    max-width: auto !important;
  } */
</style>